/**
 * Estilos compartilhados dos controles da sala. A sala tem três tamanhos:
 * - `compact`: a janela flutuante de 360 por 420 px;
 * - `room`: a janela ampliada do atendente;
 * - `guest`: a página do convidado (no celular os botões são redondos e maiores, sem a seta de menu).
 */
export const SIZE = Object.freeze({
    compact: { btn: 'h-9 w-9', chevron: 'h-9 w-6', icon: 'h-4 w-4', end: 'h-9 px-4' },
    room: { btn: 'h-12 w-12', chevron: 'h-12 w-8', icon: 'h-5 w-5', end: 'h-12 px-6' },
    guest: {
        btn: 'h-[52px] w-[52px] sm:h-12 sm:w-12',
        chevron: 'hidden sm:flex sm:h-12 sm:w-8',
        icon: 'h-5 w-5',
        end: 'h-[52px] px-5 sm:h-12 sm:px-6',
    },
});

export const TONE = Object.freeze({
    on: 'bg-white/10 text-white',
    off: 'bg-red-500/15 text-red-300 ring-1 ring-red-500/45',
    // Um recurso que está LIGADO e a pessoa precisa saber (compartilhar a tela): o ícone e o rótulo também mudam.
    active: 'bg-cyan-400/20 text-cyan-200 ring-1 ring-cyan-400/50',
});

export const FOCUS_RING = 'focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-white';

/** Botão redondo avulso (mais opções, trocar de câmera). */
export const ROUND_BUTTON =
    'inline-flex items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-white';
